export const MAX_WORKSPACE_ITEMS = 20;
